import { render } from "./EditView.vue?vue&type=template&id=4495a882&scoped=true"
import script from "./EditView.vue?vue&type=script&lang=js"
export * from "./EditView.vue?vue&type=script&lang=js"

import "./EditView.vue?vue&type=style&index=0&id=4495a882&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4495a882"]])

export default __exports__